import startCase from 'lodash/startCase';

export interface SchoolAutocompleteItem {
  description: string;
  schoolId: number;
  schoolName: string;
  districtId: number;
  districtName: string;
  gradeLevels: string;
}

export interface ChildInstitutionInput {
  institutionId: string;
  institutionName: string | null | undefined;
  hierarchyId: string;
  hierarchyName: string;
}

export function toTitleCaseLabel(text: string): string {
  const s = String(text ?? '').trim();
  if (!s) return '';
  return startCase(s);
}

export function schoolItemFromChildInstitution(
  i: ChildInstitutionInput
): SchoolAutocompleteItem | null {
  const { institutionId: instId, institutionName: name, hierarchyId, hierarchyName } = i;
  if (instId === '' || instId == null || name === '' || name == null) return null;
  const schoolId = Number(instId);
  if (Number.isNaN(schoolId)) return null;
  const label = toTitleCaseLabel(String(name));
  const districtId =
    hierarchyId !== '' && hierarchyId != null && !Number.isNaN(Number(hierarchyId))
      ? Number(hierarchyId)
      : 0;
  return {
    description: label,
    schoolId,
    schoolName: label,
    districtId,
    districtName: toTitleCaseLabel(String(hierarchyName ?? '')),
    gradeLevels: '',
  };
}

export function schoolItemFromFormSchoolField(
  value: Record<string, unknown> | null | undefined
): SchoolAutocompleteItem | null {
  if (!value || typeof value !== 'object') return null;
  const { schoolId, schoolName } = value;
  if (schoolId == null || schoolName == null) return null;
  const description = (value.description as string) ?? String(schoolName);
  const gl = value.gradeLevels;
  const gradeLevels = Array.isArray(gl) ? gl.join(',') : String(gl ?? '');

  return {
    description: toTitleCaseLabel(String(description)),
    schoolId: Number(schoolId),
    schoolName: toTitleCaseLabel(String(schoolName)),
    districtId: Number(value.districtId ?? 0),
    districtName: toTitleCaseLabel(String(value.districtName ?? '')),
    gradeLevels,
  };
}
